import { Table, TableContainer } from '@odin-labs/components';
import { useGetSiteConnectionsTabQuery } from 'apollo/generated/client-operations';
import { NewHeader } from 'components/header/NewHeader';
import { LoadingError } from 'components/loadingError';
import { getConnectionColumns } from 'connectors/components';
import { JobsiteTabProps } from 'containers/jobsite/types';
import React from 'react';

export function JobsiteConnectionsTabContainer({
  jobsiteId,
  onTabApiChange,
}: JobsiteTabProps): React.ReactElement {
  const { data, loading, error, refetch } = useGetSiteConnectionsTabQuery({
    variables: { siteId: jobsiteId },
    fetchPolicy: 'no-cache',
  });
  const connections = data?.getJobsite.connections ?? [];
  const columns = React.useMemo(() => getConnectionColumns(), []);

  React.useEffect(
    () => onTabApiChange({ refetchData: refetch }),
    [onTabApiChange, refetch],
  );
  if (error) return <LoadingError error={error} />;

  return (
    <TableContainer>
      <NewHeader
        title="Connections"
        size="md"
        actionsProps={{ headerActions: [] }}
      />
      <Table
        loading={loading}
        columns={columns}
        data={connections}
        remote
        disableGlobalFilter
        disableSortBy
      />
    </TableContainer>
  );
}
